<h1 mat-dialog-title>
  {{title}}
</h1>

<mat-radio-group [(ngModel)]="selectedOption" class="list-option-radio-group">
  @for (type of data.listOptions; track type) {
    <mat-radio-button class="list-option-radio-btn" [value]="type.value">{{type.viewValue}}</mat-radio-button>
  }
</mat-radio-group>

<div mat-dialog-actions>
  <button type="button" mat-raised-button color="primary" (click)="onConfirm()">Confirm</button>
  <button type="button" mat-button (click)="onCancel()">Cancel</button>
</div>